<template>
  <div class="login">
    <form class="login__form">
      <h1 class="title is-4">Bitte melde dich an</h1>
      <b-message type="is-danger" v-show="errors.error">
        <strong>Anmeldung fehlgeschlagen</strong><br />E-Mail und/oder Passwort
        falsch
      </b-message>
      <b-field label="Benutzername">
        <b-input
          v-model="username"
          @keydown.native.enter="$refs.password.focus()"
          ref="email"
        />
      </b-field>
      <b-field label="Passwort">
        <b-input
          v-model="password"
          type="password"
          password-reveal
          @keydown.native.enter="login"
          ref="password"
        >
        </b-input>
      </b-field>
      <div class="buttons">
        <b-button type="is-primary" expanded @click="login">Anmelden</b-button>
        <b-button type="is-primary" size="is-small" outlined expanded disabled
          >Passwort vergessen?</b-button
        >
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      username: localStorage.getItem("autofill"),
      password: "",
      loading: false,
      errors: {
        error: false
      }
    };
  },
  methods: {
    login() {
      this.errors = false;
      this.loading = true;

      this.$store.state.api
        .getToken(this.username, this.password)
        .then(response => {
          if (response.data.token) {
            localStorage.setItem("jwt", response.data.token);
            this.$router.push(this.$route.query.next || "/konto");
          } else if (response.data.error) {
            this.errors = response.data;
            if (this.errors.error === "Email does not exist.")
              this.$refs.email.focus();
            else this.$refs.password.focus();
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    redirect() {
      const redirect = sessionStorage.getItem("requested_path") || "/";
      sessionStorage.removeItem("requested_path");

      this.$router.push(redirect);
    }
  }
};
</script>

<style scoped lang="scss">
.login {
  height: 75vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
